var link_viewer_default = {
  "fontElementMap": "aPpw1",
  "link": "l04dV",
  "linkInEditor": "vgwnR",
  "linkInViewer": "ro37v",
  "toolbarUrlContainer": "_6BmAR",
  "toolbarUrl": "_9o1p5",
  "toolbarUrlAnchor": "_0FrQ-"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
